import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=824b9746&scoped=true"
var script = {}
import style0 from "./Card.vue?vue&type=style&index=0&id=824b9746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824b9746",
  null
  
)

export default component.exports